import {
  DestroyRef,
  Directive,
  inject,
  Input,
  input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { UserRoles } from '../components/login/user.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { selectUser } from '../store/user/user.selectors';

@Directive({
  selector: '[appBlockUserRoles]',
  standalone: true,
})
export class BlockUserRolesDirective implements OnInit {
  private templateRef = inject(TemplateRef);
  private viewContainerRef = inject(ViewContainerRef);
  private store = inject(Store);
  private destroyRef = inject(DestroyRef);
  private hasView = false;
  @Input() appBlockUserRoles: string[] = [];

  constructor() {}

  ngOnInit(): void {
    this.store
      .select(selectUser)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user) => {
        if (user) {
          this.updateView(user.role);
        }
      });
  }

  private updateView(role: UserRoles | null | undefined): void {
    const shouldHide = this.shouldHideElement(role);

    if (shouldHide && this.hasView) {
      // Hide the element
      this.viewContainerRef.clear();
      this.hasView = false;
    } else if (!shouldHide && !this.hasView) {
      // Show the element
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }

  private shouldHideElement(role: UserRoles | null | undefined): boolean {
    // If no user or no role, don't hide by default
    if (!role) {
      return false;
    }
    // If no blocked roles specified, don't hide
    if (!this.appBlockUserRoles || this.appBlockUserRoles.length === 0) {
      return false;
    }
    // Check if user's role is in the blocked roles list
    const shouldHide = this.appBlockUserRoles.includes(role);
    return shouldHide;
  }
}
